import { FC } from 'react';
import { Grid } from '@mui/material';
import styled from '@emotion/styled';

export const StyledEntry = styled.div`
  background-color: #ededed;
  padding: 15px 30px;
  margin-bottom: 15px;
  width: 100%;

  &:first-of-type {
    margin-top: 40px;
  }
`;

export interface Politician {
  id: string;
  originalName: string;
  correctedName: string;
  isWoman: boolean;
  party: {
    name: string;
    color: string;
  };
  attendance: {
    present: number;
    missing: number;
    percentage: number;
  };
}

interface PoliticianEntryProps {
  politician: Politician;
}

export const PoliticianEntry: FC<PoliticianEntryProps> = ({ politician }) => {
  return (
    <StyledEntry>
      <Grid container alignItems={'center'} justifyContent={'space-between'}>
        <Grid item style={{ fontSize: 18 }} xs={12} sm={6}>
          <Grid container direction="column">
            <Grid item>
              <strong>{politician.correctedName}</strong>
            </Grid>
            <Grid item>
              <div
                style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}
              >
                <svg width={18} height={18}>
                  <rect width={18} height={18} fill={politician.party.color} />
                </svg>
                <span style={{ marginLeft: 8 }}>{politician.party.name}</span>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid
            container
            alignItems="flex-end"
            justifyContent="flex-end"
            spacing={3}
          >
            <EntryItem
              title={politician.isWoman ? 'Přítomna' : 'Přítomen'}
              fontSize={24}
            >
              {politician.attendance.present?.toLocaleString?.()}x
            </EntryItem>
            {!!politician.attendance.missing && (
              <EntryItem
                title={politician.isWoman ? 'Nepřítomna' : 'Nepřítomen'}
                fontSize={24}
              >
                {politician.attendance.missing?.toLocaleString?.()}x
              </EntryItem>
            )}
            <EntryItem title="Docházka">
              {politician.attendance.percentage ?? ''} %
            </EntryItem>
          </Grid>
        </Grid>
      </Grid>
    </StyledEntry>
  );
};

interface IEntryItem {
  title?: string;
  fontSize?: number;
}

const EntryItem: FC<IEntryItem> = ({ children, title = '', fontSize = 36 }) => {
  return (
    <Grid item>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="flex-end"
        spacing={0.4}
      >
        <Grid
          item
          style={{
            fontSize: fontSize,
            fontWeight: 'bold',
          }}
        >
          {children}
        </Grid>
        {title && (
          <Grid item style={{ fontSize: 12 }}>
            {title}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
